import _ from 'lodash'

// конвертируем капчи из старых настроек. 
// Вызываем в SortableItem для слайда только 1 раз, когда у него есть флаг slideJustTranspiled.
export function convertOldVersionCaptionsFromWidgetToEditor(slide) {
    const editedSlide = _.cloneDeep(slide)
    const widgetHeight = editedSlide.widgetData.originalHeight
    
    return editedSlide.captions.map(caption => {
        let verticalCaptionOnScreen = widgetHeight - caption.position.y
        if(caption.position.y >= widgetHeight/2) {
            caption.position.y = widgetHeight - verticalCaptionOnScreen - caption.padding * 2 - caption.borderWidth * 2
        }
        return caption
    })

}

export function getCaptionContainerStyle(caption, widgetWidth, widgetHeight) {
    const _widgetHeight = widgetHeight;
    let _verticalCaptionOnScreen = _widgetHeight - caption.position.y,
        _captionStyle = {
            left: caption.position.x + 'px'
        };

    if(caption.position.y <= _widgetHeight/2){
        _captionStyle.top = caption.position.y + 'px';
    }
    else{
        _captionStyle.bottom = (_verticalCaptionOnScreen - caption.fontSize) + 'px';
    }

    return _captionStyle;
}

export function getCaptionTextStyle(caption, isLink) {
    let _style = {
        fontSize: caption.fontSize,
        lineHeight: caption.fontSize + 'px',
        minHeight: caption.fontSize,
        fontFamily: caption.fontFamily,
        color: caption.color,
        fontWeight: caption.fontWeight,
        fontStyle: caption.fontStyle,
        borderColor: caption.borderColor,
        borderRadius: caption.borderRadius,
        borderWidth: caption.borderWidth,
        borderStyle: 'solid',
        padding: caption.padding,
        backgroundColor: caption.backgroundColor,
        textShadow: caption.shadow ? '2px 1px 4px rgba(0, 0, 0, 0.7)' : null,
        cursor: isLink ? 'pointer' : '',
        margin: 0,
        opacity: 0,
        transition: '0.25s',
    };

    return _style;
}

export function getCaptionContainerStyleMobile(caption, widgetDimensions) {
    const widthDiff = widgetDimensions.mobileWidth / widgetDimensions.width
    const heightDiff = widgetDimensions.mobileHeight / widgetDimensions.height
    return {
        transform: 'translate(' + caption.position.x * widthDiff  + 'px, ' + caption.position.y * heightDiff + 'px)',
    };
}

export function getCaptionTextStyleMobile(caption, widgetDimensions) {
    const widthDiff = widgetDimensions.mobileWidth / widgetDimensions.width
    let _style = {
        fontSize: caption.fontSize * widthDiff ,
        lineHeight: caption.fontSize * widthDiff + 'px',
        minHeight: caption.fontSize * widthDiff,
        fontFamily: caption.fontFamily,
        color: caption.color,
        fontWeight: caption.fontWeight,
        fontStyle: caption.fontStyle,
        borderColor: caption.borderColor,
        borderRadius: caption.borderRadius,
        borderWidth: caption.borderWidth * widthDiff,
        borderStyle: 'solid',
        padding: caption.padding * widthDiff,
        backgroundColor: caption.backgroundColor,
        textShadow: caption.shadow ? '2px 1px 4px rgba(0, 0, 0, 0.7)' : null,
        maxWidth: 280 - 2 * caption.borderWidth * widthDiff,
        margin: 0,
        opacity: 0,
    };

    return _style;
}